import { LegalTemplate } from "./template/LegalTemplate";
import { cookies } from "../../datasets/legal/cookies";

export const Cookies = () => {
  return (
    <>
      <LegalTemplate>{toHTML(cookies)}</LegalTemplate>
    </>
  );
};

function toHTML(cookies) {
  let out = "";

  out += `<h1>${cookies.title}</h1>\n`;
  out += `<small>${cookies.date}</small>\n`;

  for (let section of cookies.sections) {
    if (section.type === "table") {
      out += `<table\n>`;

      if (section.head) {
        out += `<thead>\n<tr>\n`;
        for (let header of section.head) {
          out += `<th>${header}</th>\n`;
        }
        out += `</tr>\n</thead>\n`;
      }

      out += `<tbody>\n`;
      for (let row of section.rows) {
        out += `<tr>\n`;
        for (let cell of row) {
          out += `<td>${cell}</td>\n`;
        }
        out += `</tr>\n`;
      }
      out += `</tbody>\n`;

      out += `</table\n>`;
    } else {
      out += `<h2>${section.title}</h2>\n`;

      for (let paragraph of section.paragraphs) {
        out += `<p>${paragraph}</p>\n`;
      }
    }
  }

  return out;
}
